<template>
    <ModalBase :show-modal="true" @close-modal="close" :loading="loading" :short="true" :narrow="true" :overlay-scrollb="true" class="dashboard-modal">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal">
                <template v-slot:title>
                    <span v-translate>Manage Accountant Connection</span>
                </template>
            </TitleBar>
        </template>

        <template v-slot:maincontent>

            <dl class="gk-modal-description-list">
                <div v-for="(descItem, index) in descriptionItems" :key="index" class="gk-modal-description-list--item" :class="[descItem.type]">
                    <dt class="gk-modal-description-list--item__label">
                        {{ descItem.label }}
                    </dt>

                    <dd class="gk-modal-description-list--item__value">
                        <span>{{ descItem.value }}</span>
                    </dd>
                </div>
            </dl>

        </template>

        <template v-slot:actions>
            <div class="dashboard-modal-actions">
                <GekkoButton 
                    :text="$gettext('Disconnect')"
                    variant="link"
                    class="text-danger"
                    v-gk-confirm="{
                        title: $gettext('Disconnect accountant'),
                        message: $gettext('Are you sure that you want to disconnect from the accountant?'),
                        options: {
                            variant: 'danger',
                            confirmText: $gettext('Disconnect')
                        },
                        callback: disconnect
                    }"
                />
            </div>
        </template>
    </ModalBase>
</template>

<script>
import { mapGetters } from "vuex";

import AccountantConnectionService from "@/store/services/accountants.service";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";

export default {
    name: "AccountantInfoModal",
    components: { ModalBase, TitleBar, GekkoButton },
    props: {
        accountantCompanyProfile: {
            type: Object,
            default() {
                return {}
            }
        },
        accountantId: {
            type: Number
        }
    },
	data () {
		return {
			loading: true,
            descriptionItems: []
		}
    },
    computed: {
        ...mapGetters({ 
            currentCompany: "main/getCurrentCompany",
            getCompanyId: 'main/getCompanyId'
        })
    },
    created () {
        window.addEventListener('keydown', this.closeEventListener);
        this.descriptionItems = [
            {label: this.$gettext("Name"), value: this.accountantCompanyProfile.name},
            {label: this.$gettext("Email"), value: this.accountantCompanyProfile.email},
            {label: this.$gettext("Phone Number"), value: this.accountantCompanyProfile.phone_number},
            {label: this.$gettext("Address"), value: this.accountantCompanyProfile.address},
            {label: this.$gettext("City"), value: this.accountantCompanyProfile.city},
            {label: this.$gettext("Postal Code"), value: this.accountantCompanyProfile.postal_code},
            {label: this.$gettext("KVK"), value: this.accountantCompanyProfile.kvk},
            {label: this.$gettext("VAT"), value: this.accountantCompanyProfile.btw}
        ];
        this.loading = false;
    },
    destroyed () {
        window.removeEventListener('keydown', this.closeEventListener);
    },
    methods: {
        closeEventListener (event) {
            if (event.key === 'Escape') this.close();
        },
        close () {
            this.$emit('close-modal', false);
        },
        disconnect () {
            let params = {
                customer: this.getCompanyId,
                accountant: this.accountantId
            }

            AccountantConnectionService.getAccountantConnectionList(params).then((response) => {
                let accountantConnection = response.data[0]; // there must just be one connection per customer
                AccountantConnectionService.disconnect(accountantConnection.id).then(() => {
                    this.$store.commit("setAlert", {
                        title: this.$gettext("Success!"),
                        text: this.$gettext("Your company is not longer connected to the accountant."),
                        variant: "success",
                        duration: 4
                    });
                    this.close();
                    
                    this.$store.commit("dashboard/SET_HAS_ACCOUNTANT", false);
                    let currentCompanyCopy = JSON.parse(JSON.stringify(this.currentCompany));
                    delete currentCompanyCopy.accountant_branding;
                    this.$store.commit("main/SET_CURRENT_COMPANY", currentCompanyCopy);
                    
                    this.$emit("disconnected");
                });
            }).catch(() => {
                this.$store.commit("setAlert", {
                    title: this.$gettext("Ups!"),
                    text: this.$gettext("Your account could not be disconnected from the accountant."),
                    variant: "danger",
                    duration: 4
                });
            });
        }
    }
}
</script>

<style scoped>

</style>